// extracted by mini-css-extract-plugin
export default {"pricing-summary":"Gr","upper-column":"Hr","fully-spaced-row":"Ir"};
    if(module.hot) {
      // 1714654883834
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  